module.exports = __webpack_public_path__ + "img/recording-01.4ef76409.svg";